export const ru = {
    'image-download-error': 'При загрузке изображения произошла ошибка. Повторите позже.',
    'request-error': 'Произошла непредвиденная ошибка.'
};
